module.exports = __webpack_public_path__ + "img/pic3.6b9661f2.png";